import { Controller } from "@hotwired/stimulus"

// zarzadzanie sekcja warunki transakcji
export default class extends Controller {
  static targets = ["panel", "button", "buttonRow"]
  static outlets = ["invoice--transaction-terms-list"]

  expand(event) {
    const key = event.currentTarget.dataset.transactionTermsSubsection
    const panel = this.panelTargets.find(el => el.dataset.transactionTermsSubsection === key)
    if (!panel) return

    event.currentTarget.hidden = true
    panel.hidden = false
    this.updateButtonRowVisibility()

    const listOutlet = this.invoiceTransactionTermsListOutlets.find(outlet => panel.contains(outlet.element))
    if (listOutlet) listOutlet.add()
  }

  // sprawdza, czy nie nalezy ukryc sekcje
  collapseIfEmpty(event) {
    const key = event.detail.subsection
    const panel = this.panelTargets.find(el => el.dataset.transactionTermsSubsection === key)
    if (!panel) return

    const listOutlet = this.invoiceTransactionTermsListOutlets.find(outlet => panel.contains(outlet.element))
    if (listOutlet && panel.querySelector("[data-transaction-terms-row]:not([hidden])")) return

    panel.hidden = true
    const button = this.buttonTargets.find(el => el.dataset.transactionTermsSubsection === key)
    if (button) button.hidden = false

    this.updateButtonRowVisibility()
  }

  updateButtonRowVisibility() {
    if (this.hasButtonRowTarget) this.buttonRowTarget.hidden = this.buttonTargets.every(el => el.hidden)
  }
}
